/** Mirror of proxy `resourcelabels.NormalizeName` — keep in lockstep. */
export function normalizeResourceLabel(raw: string): string {
  let s = raw.trim().toLowerCase()
  if (s.length === 0) return ''
  s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
  if (s.length > 64) s = s.slice(0, 64).replace(/-+$/g, '')
  return s
}

export function normalizeResourceLabelList(raw: readonly string[]): string[] {
  const out: string[] = []
  const seen = new Set<string>()
  for (const r of raw) {
    const n = normalizeResourceLabel(r)
    if (!n || seen.has(n)) continue
    seen.add(n)
    out.push(n)
  }
  return out
}
